import { IndicatorType } from '../../constants/common'
import IndicatorBaseConfig from './indicatorBaseConfig'

export type Options = {
  period: number
}

export type Attrs = Options

export class MFIConfig extends IndicatorBaseConfig {
  static type = IndicatorType.Mfi
  static abbreviation = 'mfi'
  static label = 'Money Flow Index'
  static shortLabel = 'MFI'
  static description =
    'The Money Flow Index (MFI) is a momentum indicator that measures the strength of buying and selling pressure by incorporating both price and volume data. It helps identify overbought and oversold conditions, as well as potential trend reversals.'

  static optionsOrder = ['period'] as const
  static optionsLabels = { period: 'Period' }
  static inputsOrder = this.optionsOrder
  static inputsLabels = this.optionsLabels
  static calculatedValuesOrder = ['mfi'] as const
  static calculatedValuesLabels = { mfi: 'MFI' }
  static defaultCalculatedValueOption = this.calculatedValuesOrder[0]
}
